module.exports = __webpack_public_path__ + "static/805085582-wide.d0f6326c.jpg";